module.exports = __webpack_public_path__ + "img/arrow7.9065e268.svg";